
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './vue-i18n-locales.generated.js';
import KollusPlayerLauncher from './components/KollusPlayerLauncher';

/**
 * i18n vue.js plugin load
 * http://kazupon.github.io/vue-i18n/api/
 */
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: window.Laravel.lang,
    fallbackLocale: 'en',
    messages,
});

Vue.prototype.$locale = {
    change(language) {
        i18n.locale = language;
    },
    current() {
        return i18n.locale;
    },
};

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
new Vue({
    el: '#app',
    i18n,
    components: {
        'kollus-player-launcher': KollusPlayerLauncher,
    },
});
